import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HospitalityActivityPage } from "./pages/HospitalityActivityPage";
import { UserOverviewPage } from "./pages/UserOverviewPage";
import { SetupTerminalPage } from "./pages/SetupTerminalPage";
import { ImportMembersPage } from "./pages/ImportMembersPage";
import { CardCheckPointPage } from "./pages/CardCheckPointPage";
import { SetupLocationPage } from "./pages/SetupLocationPage";
import { VerifyCheckInPage } from "./pages/VerifyCheckInPage";
import { SetupProductPage } from "./pages/SetupProductPage";
import { CardCheckProductPage } from "./pages/CardCheckProductPage";

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<VerifyCheckInPage />} />
        <Route path="/import-members" element={<ImportMembersPage />} />
        <Route path="/setup-terminal" element={<SetupTerminalPage />} />
        <Route path="/setup-location" element={<SetupLocationPage />} />
        <Route path="/setup-product" element={<SetupProductPage />} />
        <Route path="/card-check-point" element={<CardCheckPointPage />} />
        <Route path="/card-check-product" element={<CardCheckProductPage />} />
        <Route path="/user-overview" element={<UserOverviewPage />} />
        <Route path="/activity" element={<HospitalityActivityPage />} />
      </Routes>
    </BrowserRouter>
  );
};
